import { render, staticRenderFns } from "./BreadcrumbMenu.vue?vue&type=template&id=3c040840"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=js"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports